import { render, staticRenderFns } from "./Eula.vue?vue&type=template&id=5cfd10d7&scoped=true"
import script from "./Eula.vue?vue&type=script&setup=true&lang=js"
export * from "./Eula.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Eula.vue?vue&type=style&index=0&id=5cfd10d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd10d7",
  null
  
)

export default component.exports